export default defineNuxtRouteMiddleware(async (to) => {
  // Only check location routes
  if (!to.path.includes('/brisbane') && !to.path.includes('/gold-coast') && !to.path.includes('/sydney')) {
    return
  }

  // Extract location slug from path
  const pathParts = to.path.split('/')
  const locationSlug = pathParts[1] // e.g., 'brisbane', 'gold-coast', 'sydney'

  // Import the location data
  const { getLocationData } = await import('~/config/locations')
  const location = getLocationData(locationSlug)

  // If location doesn't exist or is disabled, return 404
  if (!location || !location.enabled) {
    throw createError({ statusCode: 404, statusMessage: 'Location not found' })
  }
}) 